import { render, staticRenderFns } from "./UserAccountGraduate.vue?vue&type=template&id=3bcdcb2e&"
import script from "./UserAccountGraduate.vue?vue&type=script&lang=js&"
export * from "./UserAccountGraduate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports